<div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div class="field">
            <label for="nacionalidade" class="font-semibold block mb-2">Nacionalidade *</label>
            <p-select
                [appendTo]="'body'"
                id="nacionalidade"
                formControlName="nacionalidade"
                [options]="opcoesNacionalidade()"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                [readonly]="!modoEdicao()"
            />
        </div>

        @if (paisEhBrasil()) {
            <div class="field">
                <label class="font-semibold block mb-2">Naturalidade</label>
                <app-municipio-picker formControlName="municipioIdMunicipio"></app-municipio-picker>
            </div>
        }

        <div class="field">
            <label for="paisIdPais" class="font-semibold block mb-2">País de Origem</label>
            <p-select
                [appendTo]="'body'"
                id="paisIdPais"
                formControlName="paisIdPais"
                [options]="opcoesPaises()"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                [readonly]="!modoEdicao() || carregandoDominios()"
            />
        </div>

        @if (!paisEhBrasil()) {
            <div class="field">
                <label for="nmMunicipioExterior" class="font-semibold block mb-2">Município Exterior</label>
                <input pInputText id="nmMunicipioExterior" formControlName="nmMunicipioExterior" placeholder="Município no exterior" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>
        }
    </div>
</div>
